import React from 'react';
export const SECTION_ID = 'section-welcome';
import SvgTextureLineShort from 'js/components/svg/Svg.texture_line_short';

import { useInView } from 'react-intersection-observer';
import { motion, useAnimation } from 'framer-motion';

import { Link } from 'react-router-dom';

const variants = {
  hidden: {
    opacity: 0,
    scale: 0, // Start scale at 0
  },
  visible: (index) => ({
    opacity: 1,
    scale: 1, // End scale at 1
    rotate: [0, 4, -4, 0], // Rotate between 0 and 2 degrees
    transition: {
      type: 'spring', // Use spring for a bounce effect
      stiffness: 120, // Tightness of the spring
      damping: 10, // Control the spring bounce
      delay: Math.random() * 0.3 + 0.2, // Alternate delay logic
    },
  }),
  hover: {
    scale: 1.05, // End scale at 1
    rotate: [0, 4, -4, 0], // Rotate between 0 and 2 degrees
  },
};

const CallToAction = ({ item }) => {
  const controls = useAnimation();
  const { ref, inView } = useInView({
    threshold: 0.15,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [inView]);

  React.useEffect(() => {
    controls.start('hidden');
  }, []);

  const { image, link } = item;

  const renderContent = () => {
    return (
      <>
        <figure>
          <img
            src={image}
            alt={`Find more information about ${link?.text || ''}`}
            title={`Find more information about ${link?.text || ''}`}
          />
        </figure>
        <div className="content-item__body">
          <h2>{link?.text || ''}</h2>
        </div>
      </>
    );
  };

  return (
    <motion.li key={link?.text || ''} variants={variants} whileHover="hover" animate={controls} ref={ref}>
      <div className="content-item content-item--cta">
        {link && link.link_type === 'internal_page' ? (
          <Link to={`/${link.page}`}>{renderContent()}</Link>
        ) : (
          <a href={link?.external_url || ''} target="_blank" rel="noopener noreferrer">
            {renderContent()}
          </a>
        )}
      </div>
    </motion.li>
  );
};

const CtaPageBlocks = ({ ctas }) => {
  return (
    <div className="cta">
      <ul>
        {(ctas?.content || []).map((cta, index) => {
          return <CallToAction key={index} item={cta} />;
        })}
      </ul>
    </div>
  );
};

export default CtaPageBlocks;
